module.exports = __webpack_public_path__ + "97d93f875b2efad05274ef007d502403.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/privateBrokerage.png
// module id = 3255
// module chunks = 0